// extracted by mini-css-extract-plugin
export default {"card":"Login_card__nTASn","submitBtnContainer":"Login_submitBtnContainer__zAhov","loginTableContainer":"Login_loginTableContainer__MvcqY"};